export enum CommunicationRecordTargetType {
  Activity = 1,

  ProjectIntake = 2
  // Future:
  // CompanyProject = 3,
  // Invoice = 4,
}
